var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.outletName)?_c('div',{staticClass:"banner py-3 font-weight-bold text-center"},[_vm._v(" "+_vm._s(_vm.outletName)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }